// https://api.slack.com/reference/deep-linking
export function createSlackMagicLink(slackId: string) {
  return `https://tomorrowuniversity.slack.com/app_redirect?channel=${slackId}`;
}
